@if (isProfilerFeatureSelected$ | async) {
  <div>
    <div atlasStatusScreenDisableUI>
      <app-map></app-map>
    </div>
  </div>
} @else {
  <app-map></app-map>
}
@if (loadingOverlayService.loading$ | async) {
  <div class="loading-background">
    <mat-spinner class="spinner"></mat-spinner>
  </div>
}
<div class="home-container">
  <atlas-main-tools-panel></atlas-main-tools-panel>
  <atlas-properties-layout></atlas-properties-layout>
  <atlas-map-control-panel></atlas-map-control-panel>
  <atlas-copyright-notices></atlas-copyright-notices>
  <atlas-profile-status-screen></atlas-profile-status-screen>
  <!-- <atlas-expand-lofi-report></atlas-expand-lofi-report> -->
</div>
